module.exports = __webpack_public_path__ + "static/media/right-arrow-orange.e908353c.svg";